import React from 'react';

import ACT from './exams/act';
import IELTS from './exams/ielts';
import IELTS_GT from './exams/ielts_general_training';
import LSAT from './exams/lsat';
import TOEFL from './exams/toefl';
import TOEFLJanuary2026 from './exams/toefl_january2026';

interface Props {
  curriculumVersion: string;
  examName: string;
}

const DescriptionContent = (props) => {
  const slug = props.examName.trim().toLowerCase().replace(/ /g, '_');

  const DefaultDescriptionContent = () => (
    <>
      <p>This practice test simulates the experience you will have taking the {props.examName} on test day.</p>
      <p>When you finish the test, we will give you a <strong>score estimate</strong> which will help you predict how well you would do on the actual {props.examName}. You'll also be able to <strong>review your answers</strong> and see the video explanations.</p>
    </>
  );

  if (slug === 'act') {
    return <ACT />;
  } else if (slug === 'ielts') {
    return <IELTS />;
  } else if (slug === 'ielts_general_training') {
    return <IELTS_GT />;
  } else if (slug === 'lsat') {
    return <LSAT />;
  } else if (slug === 'toefl' && props.curriculumVersion === 'default') {
    return <TOEFL />;
  } else if (slug === 'toefl' && props.curriculumVersion === '2026_toefl') {
    return <TOEFLJanuary2026 />;
  } else {
    return <DefaultDescriptionContent />;
  }
};

export default DescriptionContent;
